<template>
  <PageWrapper :isLoading="isLoading" hasFilters @submitFilters="setFilters">
    <template #title> لیست مدیر های زبان </template>
    <template #titleBtn>
      <BButton variant="success" to="/apps/language-managers/create">
        ایجاد مدیر زبان جدید
      </BButton>
    </template>
    <template #filters>
      <SearchInput
        inputId="searchCommand"
        inputLabel="جستجوی زبان"
        inputPlaceholder="انگلیسی"
        v-model="languageMastersFilters.searchCommand"
        @enter="setFilters"
      ></SearchInput>
    </template>
    <CustomTable
      :pageNumber="languageMastersFilters.pageNumber"
      :count="languageMastersFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="languageMasterList"
      @changePage="changePage"
    >
      <template #index="data">
        {{
          Math.ceil(
            data.index +
              1 +
              (languageMastersFilters.pageNumber - 1) *
                languageMastersFilters.count
          )
        }}
      </template>
      <template #language="data">
        <b-link :to="`/languages/${data.item.language.id}/lessons`">
          {{ data.item.language.persianTitle }}
        </b-link>
      </template>
      <template #user="data">
        <b-link :to="`/users/${data.item.user.id}`">
          {{ data.item.user.fullName }} ({{ data.item.user.phoneNumber }})
        </b-link>
      </template>
      <template #actions="data">
        <div class="d-flex align-items-center">
          <BButton
            variant="transparent"
            size="sm"
            :to="`/apps/language-managers/${data.item.id}`"
          >
            <FeatherIcon icon="EditIcon" size="23" class="text-info" />
          </BButton>
          <BButton
            variant="transparent"
            size="sm"
            @click="renderDeleteLanguageManagerConfirmationDialog(data.item)"
          >
            <FeatherIcon icon="Trash2Icon" size="23" class="text-danger" />
          </BButton>
        </div>
      </template>
    </CustomTable>

    <DeleteLanguageManagerConfirmationDialog
      :defaultLanguageManager="tempSelectedLanguageManager"
      @refetch="sendGetAllLanguageManagersRequest"
    ></DeleteLanguageManagerConfirmationDialog>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    if (this.computedPageRouteQuery) {
      this.languageMastersFilters.pageNumber = this.computedPageRouteQuery;
    } else {
      this.languageMastersFilters.pageNumber = 1;
    }
    this.sendGetAllLanguageManagersRequest();
  },
  data() {
    return {
      isLoading: false,
      languageMastersFilters: {
        pageNumber: 1,
        count: 10,
        searchCommand: null,
      },
      languageMasterList: null,
      totalCount: null,
      tableColumns: [
        {
          key: "index",
          label: "ردیف",
        },
        {
          key: "language",
          label: "زبان",
        },
        {
          key: "user",
          label: "کاربر",
        },
        {
          key: "userPercentIncome",
          label: "درصد درآمد کاربر",
          formatter: (val) => `${val}%`,
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
      tempSelectedLanguageManager: null,
    };
  },
  methods: {
    renderDeleteLanguageManagerConfirmationDialog(selectedLanguageManager) {
      this.tempSelectedLanguageManager = selectedLanguageManager;
      this.$bvModal.show("delete-language-manager-confirmation-dialog");
    },
    setFilters() {
      this.languageMastersFilters.pageNumber = 1;
      this.sendGetAllLanguageManagersRequest();
    },
    changePage(pageNumber) {
      this.languageMastersFilters.pageNumber = pageNumber;
      this.setPageNumberQuery(pageNumber);
    },
    setPageNumberQuery(pageNumber) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: pageNumber,
        },
      });
    },
    async sendGetAllLanguageManagersRequest() {
      try {
        this.isLoading = true;
        const _this = this;
        const getAllLanguageManagers = new GetAllLanguageManagers(_this);
        getAllLanguageManagers.setRequestParam(_this.languageMastersFilters);
        await getAllLanguageManagers.fetch((res) => {
          _this.languageMasterList = res.data.data;
          _this.totalCount = res.data.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    computedPageRouteQuery() {
      if (this.$route.query && this.$route.query.page) {
        return this.$route.query.page;
      }
      return null;
    },
  },
  components: {
    DeleteLanguageManagerConfirmationDialog,
    PageWrapper,
    SearchInput,
    CustomTable,
    BButton,
    BLink,
  },
};
import DeleteLanguageManagerConfirmationDialog from "@/views/components/LanguageManagers/DeleteLanguageManagerConfirmationDialog.vue";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import { BButton, BLink } from "bootstrap-vue";
import { GetAllLanguageManagers } from "@/libs/Api/LanguageManagers";
</script>
